const WrapUpStatus = ({ submitting, loggedIn }: { submitting?: boolean | null; loggedIn: boolean }) => {
  if (!submitting && !loggedIn) return <span className="text-xs text-muted-foreground">—</span>;
  return (
    <span
      className={
        'inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-0.5 text-[11px] font-semibold ring-1 ring-inset ' +
        (submitting
          ? 'bg-amber-100 text-amber-700 ring-amber-200 dark:bg-amber-950/40 dark:text-amber-300'
          : 'bg-muted/60 text-muted-foreground ring-border/60')
      }
    >
      <span className={'h-[7px] w-[7px] rounded-full ' + (submitting ? 'bg-amber-500' : 'bg-slate-400')} />
      {submitting ? 'In Progress' : 'Not Started'}
    </span>
  );
};

export default WrapUpStatus;
